import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";
import { SettingsPage } from "@/components/admin/settings/SettingsPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/settings")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="settings">
      <SettingsPage />
    </AdminShell>
  ),
});
